module.exports = __webpack_public_path__ + "static/media/4-10.a7f19a68.mp3";